export const resumeLink: string =
  "https://drive.google.com/file/d/1akrW7MMacxWr-BEo3C2WNsitHugqKMXk/view?usp=sharing";
export const telegramProfile: string = "https://t.me/ergo404";
